export enum HubSpotDeleteAction {
	Archive,
	Purge,
}
